export const esLang = {
  contact: 'Contacto',
  people: 'Equipo',
  ourPractice: 'Áreas de Práctica',
  ourFirm: 'La Firma'
};

export default esLang;
